import _regeneratorRuntime from "@babel/runtime/regenerator";
import { canUseDOM } from 'fbjs/lib/ExecutionEnvironment';
import uuidv4 from 'uuid/v4';
var ID_KEY = 'EXPO_CONSTANTS_INSTALLATION_ID';

var _sessionId = uuidv4();

function getBrowserName() {
  if (canUseDOM) {
    var agent = navigator.userAgent.toLowerCase();

    if (agent.includes('edge')) {
      return 'Edge';
    } else if (agent.includes('edg')) {
      return 'Chromium Edge';
    } else if (agent.includes('opr') && !!window['opr']) {
      return 'Opera';
    } else if (agent.includes('chrome') && !!window['chrome']) {
      return 'Chrome';
    } else if (agent.includes('trident')) {
      return 'IE';
    } else if (agent.includes('firefox')) {
      return 'Firefox';
    } else if (agent.includes('safari')) {
      return 'Safari';
    }
  }

  return undefined;
}

export default {
  get name() {
    return 'ExponentConstants';
  },

  get appOwnership() {
    return 'expo';
  },

  get installationId() {
    var installationId;

    try {
      installationId = localStorage.getItem(ID_KEY);

      if (installationId == null || typeof installationId !== 'string') {
        installationId = uuidv4();
        localStorage.setItem(ID_KEY, installationId);
      }
    } catch (error) {
      installationId = _sessionId;
    } finally {
      return installationId;
    }
  },

  get sessionId() {
    return _sessionId;
  },

  get platform() {
    return {
      web: canUseDOM ? {
        ua: navigator.userAgent
      } : undefined
    };
  },

  get isHeadless() {
    return false;
  },

  get isDevice() {
    return true;
  },

  get isDetached() {
    return false;
  },

  get expoVersion() {
    return this.manifest.sdkVersion || null;
  },

  get linkingUri() {
    if (canUseDOM) {
      return location.origin + location.pathname;
    } else {
      return '';
    }
  },

  get expoRuntimeVersion() {
    return this.expoVersion;
  },

  get deviceName() {
    return getBrowserName();
  },

  get nativeAppVersion() {
    return null;
  },

  get nativeBuildVersion() {
    return null;
  },

  get systemFonts() {
    return [];
  },

  get statusBarHeight() {
    return 0;
  },

  get deviceYearClass() {
    return null;
  },

  get manifest() {
    return process.env.APP_MANIFEST || {};
  },

  get experienceUrl() {
    if (canUseDOM) {
      return location.origin + location.pathname;
    } else {
      return '';
    }
  },

  get debugMode() {
    return __DEV__;
  },

  getWebViewUserAgentAsync: function getWebViewUserAgentAsync() {
    return _regeneratorRuntime.async(function getWebViewUserAgentAsync$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!canUseDOM) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", navigator.userAgent);

          case 4:
            return _context.abrupt("return", null);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, null, null, null, Promise);
  }
};